var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 7.00001H23.0375L21.3375 4.45001C21.247 4.31059 21.1229 4.19625 20.9765 4.11759C20.8301 4.03893 20.6662 3.99848 20.5 4.00001H12.5C12.3338 3.99848 12.1699 4.03893 12.0235 4.11759C11.8771 4.19625 11.753 4.31059 11.6625 4.45001L9.9625 7.00001H6.5C5.70536 7.0033 4.94421 7.32043 4.38231 7.88233C3.82042 8.44422 3.50329 9.20537 3.5 10V24C3.50329 24.7946 3.82042 25.5558 4.38231 26.1177C4.94421 26.6796 5.70536 26.9967 6.5 27H26.5C27.2946 26.9967 28.0558 26.6796 28.6177 26.1177C29.1796 25.5558 29.4967 24.7946 29.5 24V10C29.4967 9.20537 29.1796 8.44422 28.6177 7.88233C28.0558 7.32043 27.2946 7.0033 26.5 7.00001ZM21 16.5C21 17.39 20.7361 18.2601 20.2416 19.0001C19.7471 19.7401 19.0443 20.3169 18.2221 20.6575C17.3998 20.9981 16.495 21.0872 15.6221 20.9135C14.7492 20.7399 13.9474 20.3113 13.318 19.682C12.6887 19.0527 12.2601 18.2508 12.0865 17.3779C11.9128 16.505 12.0019 15.6002 12.3425 14.7779C12.6831 13.9557 13.2599 13.2529 13.9999 12.7584C14.74 12.2639 15.61 12 16.5 12C17.6935 12 18.8381 12.4741 19.682 13.318C20.5259 14.1619 21 15.3065 21 16.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.51e6d87d830de7e616e6c2ad367fb15e.svg";
export { ForwardRef as ReactComponent };